// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-testid=\"button-stack\"] > div {\n    flex: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
